module.exports = __webpack_public_path__ + "static/media/success.8db8950b.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/audio/success.ogg
// module id = 404
// module chunks = 0